// create component for chars of characters
import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { ListCharactersContextInterface } from "../../interfaces/charactersList.Interfaces";
import { ListCharactersContext } from "../../contexts/charactersList.context";
import { IChar } from "../../interfaces/chars.interfaces";

export const CharGender = () => {
  const { ElementList } = React.useContext(
    ListCharactersContext
  ) as ListCharactersContextInterface;

  // function definition the gender of ElementList
  const genderList = () => {
    const gender: Array<IChar> = [];
    ElementList.forEach((element) => {
      if (!gender.find((item) => item.name === element.gender)) {
        gender.push({
          name: element.gender,
          y: 1,
        });
      } else {
        const index = gender.findIndex((item) => item.name === element.gender);
        gender[index].y++;
      }
    });
    return gender;
  };

  // funtion definition for char gender
  const optionsCharGender = () => {
    const charGender = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: "pie",
      },
      title: {
        text: "Gender of Rick and Morty Characters per page",
      },
      tooltip: {
        pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
      },
      accessibility: {
        point: {
          valueSuffix: "%",
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: true,
            format: "<b>{point.name}</b>: {point.percentage:.1f} %",
          },
        },
      },
      series: [
        {
          name: "Gender",
          colorByPoint: true,
          data: genderList(),
        },
      ],
      credits: {
        text: '',
      }
    };
    return charGender;
  };

  return (
    <HighchartsReact highcharts={Highcharts} options={optionsCharGender()} />
  );
};

export default CharGender;
